import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import styled from 'styled-components'
import Navigation from 'components/navigation'
import OpenGraph from 'common/open-graph'
import Wrapper from 'common/wrapper'
import { prefetchCourses, useCourses } from 'querys/course'
import { Typography } from 'common/typography'
import InternalError from 'errors/internal-error'
import CourseList from 'courses/list'
import Footer from 'common/footer'

const CourseStyled = styled.main`
  padding: 80px 0 64px;
  @media(min-width: 768px) {
    padding: 24px 0 64px;
  }
`

function Courses() {
  const { error } = useCourses()

  if (error?.message === 'Internal Error') return <InternalError />

  return (
    <>
      <OpenGraph
        title="Cursos"
        url="https://leonidasesteban.com/cursos"
        keyword="Cursos de Desarrolo Web, Cursos de React, leonidasesteban.com, La mejor carrera de Frontend, Leonidas Esteban"
        description="Bienvenido a la mejor carrera de desarrollo web, aqui podras encontrar tu learning path para convertirte en un Frontend de excelencia teniendo a los mas grandes expertos de las tecnologias web como tus mentores"
        image="/images/blog/mockup-home.jpg"
      />
      <Navigation background="var(--sky)" />
      <CourseStyled>
        <Wrapper maxWidth="1200" aria-labelledby="course-titles">
          <Typography id="course-titles" as="h1" small="headline5" large="headline4" color="var(--neutralText)">
            Todos los cursos
          </Typography>
          <CourseList />
        </Wrapper>
      </CourseStyled>
      <Footer />
    </>
  )
}

Courses.pageTheme = {
  background: 'var(--sky)',
}

export async function getStaticProps() {
  const queryClient = new QueryClient()
  await prefetchCourses(queryClient)
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: 3600,
  }
}

export default Courses
